import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Search = () => {
    const location = useLocation()

    const [navigationCollapsed, setNavigationCollapsed] = useState(false)
    const [searchTerm, setSearchTerm] = useState('')
    const [portfolioSearchResults, setPortfolioSearchResults] = useState([])
    const [qualitySearchResults, setQualitySearchResults] = useState([])
    const [doRenderSearchResults, setDoRenderSearchResults] = useState(false)

    const search = (event) => {
        const search_term = event && event.target ? event.target.value : ''
        setSearchTerm(search_term)
        if( search_term.length < 3 ) {
            setPortfolioSearchResults([])
            setQualitySearchResults([])
            setDoRenderSearchResults(false)
            return
        }
        fetch(`/v0/cadm_search_all?query=${search_term}`, { credentials: 'same-origin' })
            .then(function(response) {
                return response.json()
            })
            .then(function(json) {
                setPortfolioSearchResults(json.result.portfolio)
                setQualitySearchResults(json.result.quality)
                setDoRenderSearchResults(true)
            })
    }

    const renderSearchResults = () => {
        let output = []
        output.push(<h2 className="search-results">Portfolio</h2>)
        output.push(
            portfolioSearchResults.map(section => {
                return (
                    <div>
                        <h3 className="search-results"><i className={section.icon}></i> {section.title} ({section.results.length})</h3>
                        <ul className="search-results">
                            {section.results.map((item,index) => {
                                return (<li className="search-results">
                                    <Link to={`/portfolio/${item.project_id}/${section.type}/${item.id}`}>
                                        {item.display_name}
                                    </Link><br/>
                                    <small className="search-results">{item.project_type}: {item.project_name} | Status: {item.object_status}</small>
                                </li>)
                            })}
                        </ul>
                    </div>
                )
            })
        )
        output.push(<h2 className="search-results">Quality</h2>)
        output.push(
            qualitySearchResults.map(section => {
                return (
                    <div>
                        <h3 className="search-results"><i className={section.icon}></i> {section.title} ({section.results.length})</h3>
                        <ul className="search-results">
                            {section.results.map((item,index) => {
                                return (<li className="search-results">
                                    <Link to={`/${section.type}/${item.id}`}>
                                        {item.display_name}
                                    </Link><br/>
                                    <small className="search-results">{section.title} | Status: {item.object_status}</small>
                                </li>)
                            })}
                        </ul>
                    </div>
                )
            })
        )
        return output
    }
    
    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        
                        <div className="ibox-title">
                            <h2 className="search-header">Find Configured Items
                            </h2>
                        </div>
                        
                        <div className="ibox-content">
                            <form className="form-horizontal">
                                <div className="row">
                                    <span className="text-input-wrapper searchbox-wrapper" key="wrapper">
                                        <span title="Search" className="searchbox-search" key="search">
                                            <i className="fa fa-search"></i>
                                        </span>
                                        <input
                                            key="input"
                                            className="input-sm form-control input-s-sm inline searchbox-input"
                                            type="search"
                                            id="searchbox"
                                            placeholder="Search..."
                                            value={searchTerm} onChange={search}
                                        />
                                    </span>
                                </div>
                                
                                {doRenderSearchResults &&
                                    <div className="row" style={{padding: 10}}>
                                        {renderSearchResults()}
                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Search
